module.exports = __webpack_public_path__ + "static/img/12.bf21bf8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/12.png
// module id = WdnV
// module chunks = 0